module.exports = __webpack_public_path__ + "static/media/PhilsLabLogo.163b84f6.png";